import { ratingColors5, ratingColors6 } from "./rating"

const profileKeys = {
    1: {
        words_per_minute: "בטווח המצופה",
        factored_percent_accuracy: "בטווח המצופה",
        percent_accuracy: "בטווח המצופה",
        fluency_reading: "רציפה",
        correct_words_per_minute: "בטווח המצופה",
        prosody: "מתאימה",
        color: "#85A81F",
        bg: "#E4F1D1"
    },
    2: {
        words_per_minute: "בינוני",
        factored_percent_accuracy: "בינוני",
        percent_accuracy: "בינוני",
        fluency_reading: "מעט מקוטעת",
        correct_words_per_minute: "בינוני",
        prosody: "בינונית",
        color: ratingColors5[3],
        bg: ratingColors6[3]
    },
    3: {
        words_per_minute: "איטי",
        factored_percent_accuracy: "נמוך",
        percent_accuracy: "נמוך",
        fluency_reading: "מקוטעת",
        correct_words_per_minute: "נמוך",
        prosody: "לא מתאימה",
        color: ratingColors5[4],
        bg: ratingColors6[4]
    }
}

export default profileKeys